import EDC from '@/components/games/shared/globals';

/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton = function (scene, parent, x, y) {
  this.scene = scene;
  this.parent = parent;
  this.x = x;
  this.y = y;

  this.normal = null;
  this.over = null;
  this.down = null;
  this.disabled = null;

  this.isDisabled = false;
  this.cursorManager = scene.cursorManager;

  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.create = function () {
  this.normal = this.scene.add.sprite(this.x, this.y, 'list-arrow-normal');
  this.over = this.scene.add.sprite(this.x, this.y, 'list-arrow-light');
  this.down = this.scene.add.sprite(this.x, this.y, 'list-arrow-dark');
  this.disabled = this.scene.add.sprite(this.x, this.y, 'list-arrow-disabled');

  this.over.setAlpha(0);
  this.down.setAlpha(0);
  this.disabled.setAlpha(0);

  this.parent.add([this.normal, this.over, this.down, this.disabled]);

  this.cursorManager.setDefaultDraggableEvents(this.normal);
  this.normal.setInteractive();
  this.normal.on('pointerover', this.onOver, this);
  this.normal.on('pointerout', this.onOut, this);
  this.normal.on('pointerdown', this.onDown, this);
  this.normal.on('pointerup', this.onUp, this);

  this.onUpCallback = null;

  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.setUpCallback = function (callback) {
  this.onUpCallback = callback;
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.onOver = function () {
  if (this.isDisabled) return;
  this.over.setAlpha(1);
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.onOut = function () {
  if (this.isDisabled) return;
  this.normal.setAlpha(1);
  this.over.setAlpha(0);
  this.down.setAlpha(0);
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.onDown = function () {
  if (this.isDisabled) return;
  this.over.setAlpha(0);
  this.down.setAlpha(1);
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.onUp = function () {
  if (this.isDisabled) return;
  this.over.setAlpha(1);
  this.down.setAlpha(0);
  if (this.onUpCallback) this.onUpCallback();
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.setPosition = function (x,
  y, isAbsolute = true) {
  if (!isAbsolute) {
    this.x += x;
    this.y += y;
  } else {
    this.x = x;
    this.y = y;
  }
  this.normal.setPosition(this.x, this.y);
  this.over.setPosition(this.x, this.y);
  this.down.setPosition(this.x, this.y);
  this.disabled.setPosition(this.x, this.y);
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.getHeight = function () {
  return this.normal.height;
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.disable = function (isDisable = true) {
  if (isDisable) {
    this.isDisabled = true;
    this.disabled.setAlpha(1);
  } else {
    if (!this.isDisabled) return;
    this.isDisabled = false;
    this.disabled.setAlpha(0);
    this.over.setAlpha(0);
  }
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.rotate = function (angleInDeg) {
  this.normal.setAngle(angleInDeg);
  this.over.setAngle(angleInDeg);
  this.down.setAngle(angleInDeg);
  this.disabled.setAngle(angleInDeg);
};
/**
 *
 */
EDC.Games.AvatarSelect.ScrollButton.prototype.setDepth = function (depth) {
  this.normal.setDepth(depth);
  this.over.setDepth(depth);
  this.down.setDepth(depth);
  this.disabled.setDepth(depth);
};

export default EDC.Games.AvatarSelect.ScrollButton;
